import { useLayoutContext } from "@context/layout";
import ArrowLeft2Icon from "@svg/new-design/arrow-left2";
import { stringifiedFarsiNum } from "@utils/digits";
import SubscriptionShineIcon from "@svg/new-design/SubscriptionShineIcon";
import Link from "next/link";
import { FC, useMemo } from "react";

const SidebarSubscriptionBanner: FC<{ isFree: boolean }> = ({ isFree }) => {
  const { staticData, subscriptionData } = useLayoutContext();
  const hasSubscription = Boolean(subscriptionData?.is_active);

  if (hasSubscription) return null;

  const formattedCountLabel = useMemo(
    () =>
      stringifiedFarsiNum(staticData?.statistics?.countOfProducts ?? 0, 17_000),
    [staticData?.statistics?.countOfProducts]
  );

  const description = isFree
    ? `دسترسی به همه ${formattedCountLabel}+ آموزش فرادرس، تنها با یک اشتراک`
    : `دسترسی به این آموزش و ${formattedCountLabel}+ آموزش دیگر‌، با یک
            اشتراک`;

  return (
    <Link target="_blank" href="/subscription" prefetch={false} passHref>
      <div className="flex w-full relative rounded-8 mx-1 mt-4 h-10  subscription-gradient-border ">
        <div className="items-center product-banner-bg rounded-8 px-3 flex w-full relative ">
          <SubscriptionShineIcon
            width={24}
            height={24}
            role="img"
            aria-label="Faradars subscription"
          />
          <p className="headline-xxsm mr-1.5">{description}</p>
          <ArrowLeft2Icon className="w-4 h-4 absolute left-3 top-3  text-fds-icon-secondary" />
        </div>
      </div>
    </Link>
  );
};

export default SidebarSubscriptionBanner;
